import {Component, EventEmitter, forwardRef, inject, Input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ConfigService} from '../../../../core/services';
import {AdminUserModel} from '../../../../api/model/Admin-user.model';

@Component({
  selector: 'tj-admin-combobox',
  templateUrl: './admin-combobox.component.html',
  styleUrls: ['./admin-combobox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AdminComboboxComponent),
      multi: true,
    },
  ],
})
export class AdminComboboxComponent implements OnInit, ControlValueAccessor {
  private configService = inject(ConfigService);

  @Input() disabled = false;
  @Output() adminChange = new EventEmitter();

  allAdmins: AdminUserModel[] = [];
  filteredAdmins: AdminUserModel[] = [];

  private onTouchedCallback: Function;

  private onChangeCallback: Function;

  innerValue = null;

  constructor() {
  }

  get value(): any {
    return this.innerValue;
  }

  set value(v: any) {
    this.innerValue = v;
    const finalValue = v && v.id;
    if (this.onChangeCallback) {
      this.onChangeCallback(finalValue);
    }

    if (this.onAdminChange) {
      this.onAdminChange(finalValue);
    }
  }

  ngOnInit() {
    this.configService.admins$.subscribe(value => {
      this.allAdmins = value;
    });
    if (this.disabled && this.allAdmins && this.allAdmins.length > 0) {
      this.value = this.allAdmins[0];
      return;
    }
  }

  onAdminChange(adminId: number): void {
    this.adminChange.emit(adminId);
  }

  onBlur(): void {
    this.onTouchedCallback();
  }

  writeValue(id: any): void {
    this.innerValue = this.allAdmins.find(p => p.id === id);
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  onFilterSuggestions(event) {
    const lower = (event.query || '').toLowerCase();
    this.filteredAdmins = this.allAdmins.filter(admin =>
      `${admin.firstName} ${admin.lastName}`.toLowerCase().includes(lower) ||
      (admin.email || '').toLowerCase().includes(lower)
    );
  }
}
